import { DEAL_TYPE_ID, COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { HUBSPOT_DEFINED } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { useState, useMemo, useCallback } from 'react';
import useHasCompletedPaymentsApplication from '../commercePayment/hooks/useHasCompletedPaymentsApplication';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error Untyped import
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import useFetchDealCurrency from './hooks/useFetchDealCurrency';
import useFetchRecordName from './hooks/useFetchRecordName';
import useFetchDealLineItems from './hooks/useFetchDealLineItems';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMutation } from '@apollo/client';
import { CreateCrmObjectAssociationBySpec } from '../../../hooks/useCreateCrmObjectAssociationBySpecMutationQueries';
import { _tracker } from 'customer-data-tracking/tracker';
// @ts-expect-error Untyped import
import { trackSpecificPropertyEvent } from 'customer-data-sidebar/tracking/events';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getValidatedLineItemsQuery } from './queries/restQueries';
import { useQuery } from 'data-fetching-client';
import { useMultiCurrencyStatus } from './hooks/useMultiCurrencyStatus';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import PaymentLinkAssociationPanelAsync from './PaymentLinkAssociationPanelAsync';
import SharePaymentLinkModalAsync from './SharePaymentLinkModalAsync';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { commerceAnalyticsDataBinding } from 'growth-payments-core/hooks/useCommerceAnalyticsData';
import { getNetworkBindingData } from 'growth-payments-core/binding/getNetworkBindingData';
import Raven from 'raven-js';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PAYMENT_LINK_CARD_ACTION_ADD_DROPDOWN_ID = 'payment-link-card-action-add-dropdown';
export const PAYMENT_LINK_CARD_CONVERT_DEAL_BUTTON_ID = 'payment-link-card-convert-deal-button';

/**
 * TODO replace this with a global const
 * https://git.hubteam.com/HubSpot/PaymentsPostEnrollPlanning/issues/467
 *
 * Temporary list copied from
 * https://knowledge.hubspot.com/payments/use-multiple-currencies-with-stripe#available-currencies
 */
const ACCEPTED_CURRENCIES = ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'ISK', 'JMD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KRW', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SEK', 'SGD', 'SHP', 'SLE', 'SOS', 'SRD', 'STD', 'SZL', 'THB', 'TJS', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VND', 'VUV', 'WST', 'XAF', 'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW'];
const EMBED_MESSAGE_TYPES = {
  MODAL_CLOSE: 'MODAL_CLOSE',
  PAYMENT_LINK_CREATED: 'PAYMENT_LINK_CREATED'
};
const CLICK_PAYMENT_LINK_ADD_ACTION = 'click payment link add';
const CREATE_PAYMENT_LINK_FROM_DEAL_ACTION = 'click create new payment link from deal';
const CONVERT_PAYMENT_LINK_FROM_DEAL_ACTION = 'click convert payment link from deal';
const ASSOCIATE_PAYMENT_LINK_TO_DEAL_ACTION = 'click add existing payment link to deal';
const PaymentLinkCardAction = ({
  associationTypeData,
  canEditAssociation,
  toObjectTypeId,
  fromObjectTypeId,
  fromObjectId,
  hasScope
}) => {
  var _validatedLineItemsDa;
  const [shouldDisplayCreateIframe, setShouldDisplayCreateIframe] = useState(false);
  const [shouldDisplayConvertDealIframe, setShouldDisplayConvertDealIframe] = useState(false);
  const [shouldDisplayPaymentLinkAssociationPanel, setShouldDisplayPaymentLinkAssociationPanel] = useState(false);
  const sendUpdateAssociationsMessage = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS);
  const [isPaymentLinkModalOpen, setIsPaymentLinkModalOpen] = useState(false);
  const [paymentLinkCrmObjectId, setPaymentLinkCrmObjectId] = useState(0);
  const [paymentLinkId, setPaymentLinkId] = useState(0);
  const viewingOnPaymentRecord = fromObjectTypeId === COMMERCE_PAYMENT_TYPE_ID;
  const viewingOnDealRecord = fromObjectTypeId === DEAL_TYPE_ID;
  const canEditPaymentLinks = hasScope('payment-links-write');
  const portalId = PortalIdParser.get();
  const getCommerceAnalyticsData = () => getNetworkBindingData(commerceAnalyticsDataBinding);
  const handleTrackingAction = useCallback(action => {
    trackSpecificPropertyEvent(_tracker, {
      action
    });
  }, []);
  const handleTrackingActionWithCommerceAnalytics = useCallback(action => {
    getCommerceAnalyticsData().then(({
      isEnrolled,
      isActivated,
      processorType
    }) => {
      CrmLogger.log('sidebar-interaction', {
        action,
        isEnrolled,
        isActive: isActivated,
        processorType
      });
    }).catch(error => {
      Raven.captureException(error);
      handleTrackingAction(action);
    });
  }, [handleTrackingAction]);
  const skipFetchDealCurrency = !viewingOnDealRecord;
  const dealCurrency = useFetchDealCurrency(fromObjectId, skipFetchDealCurrency);
  const recordName = useFetchRecordName(fromObjectId, fromObjectTypeId);
  const {
    allArchivedCurrencies
  } = useMultiCurrencyStatus();
  const {
    dealLineItemNodes,
    lineItemObjectIds
  } = useFetchDealLineItems(fromObjectId, !viewingOnDealRecord);
  const {
    data: validatedLineItemsData
  } = useQuery(getValidatedLineItemsQuery, {
    skip: !dealLineItemNodes || !lineItemObjectIds || dealLineItemNodes.length === 0 || lineItemObjectIds.length === 0 || !viewingOnDealRecord,
    variables: {
      lineItemObjectIds,
      portalId,
      sourceCurrency: dealCurrency
    }
  });
  const areLineItemsValid = (validatedLineItemsData === null || validatedLineItemsData === void 0 || (_validatedLineItemsDa = validatedLineItemsData.validateLineItems) === null || _validatedLineItemsDa === void 0 ? void 0 : _validatedLineItemsDa.isValid) || false;
  const isDealCurrencyUnsupported = useMemo(() => viewingOnDealRecord && !!dealCurrency && !ACCEPTED_CURRENCIES.includes(dealCurrency), [viewingOnDealRecord, dealCurrency]);
  const isDealCurrencyArchived = useMemo(() => viewingOnDealRecord && !!dealCurrency && allArchivedCurrencies.includes(dealCurrency), [viewingOnDealRecord, allArchivedCurrencies, dealCurrency]);
  const {
    completedApplication
  } = useHasCompletedPaymentsApplication();
  const PAYMENT_LINKS_URL = `/payment-links/${portalId}`;
  const editAssociationOverrideMessage = useMemo(() => {
    if (viewingOnPaymentRecord) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociateObjectButton.tooltip.paymentLinkPermissionTooltipTextOverride"
      });
    } else if (isDealCurrencyUnsupported) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociateObjectButton.tooltip.paymentLinkPermissionTooltipTextOverrideUnsupportedCurrency"
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "cardAssociatedObjects.AssociateObjectButton.tooltip.paymentApprovalPending_jsx",
      options: {
        external: true,
        href: PAYMENT_LINKS_URL
      },
      elements: {
        Link
      }
    });
  }, [viewingOnPaymentRecord, isDealCurrencyUnsupported, PAYMENT_LINKS_URL]);
  const [createAssociationBySpecMutation] = useMutation(CreateCrmObjectAssociationBySpec);
  const handleMessageFromIframe = useCallback(message => {
    const {
      payload: {
        type,
        data
      }
    } = message;
    if (type === EMBED_MESSAGE_TYPES.PAYMENT_LINK_CREATED && data) {
      createAssociationBySpecMutation({
        variables: {
          createAssociationInput: {
            fromObjectTypeAndId: {
              objectTypeId: fromObjectTypeId,
              objectId: fromObjectId
            },
            toObjectTypeAndId: {
              objectTypeId: toObjectTypeId,
              objectId: data.crmObjectId
            },
            associationSpecs: [{
              associationCategory: HUBSPOT_DEFINED,
              associationTypeId: associationTypeData.associationTypeId
            }]
          }
        }
      }).then(() => {
        sendUpdateAssociationsMessage({
          objectId: `${fromObjectId}`,
          objectTypeId: toObjectTypeId,
          toObjectTypeId
        });
      }).catch(() => {});
      setIsPaymentLinkModalOpen(true);
      setPaymentLinkCrmObjectId(Number(data.crmObjectId));
      setPaymentLinkId(Number(data.paymentLinkId));
    } else if (type === EMBED_MESSAGE_TYPES.MODAL_CLOSE) {
      if (shouldDisplayCreateIframe) {
        setShouldDisplayCreateIframe(false);
      } else if (shouldDisplayConvertDealIframe) {
        setShouldDisplayConvertDealIframe(false);
      }
    }
  }, [createAssociationBySpecMutation, fromObjectTypeId, fromObjectId, toObjectTypeId, associationTypeData.associationTypeId, sendUpdateAssociationsMessage, shouldDisplayCreateIframe, shouldDisplayConvertDealIframe]);
  const shouldShowConvertDealToLink = useMemo(() => viewingOnDealRecord && dealLineItemNodes && dealLineItemNodes.length !== 0, [dealLineItemNodes, viewingOnDealRecord]);
  const shouldDisableConvertDealToLink = useMemo(() => !canEditPaymentLinks || !areLineItemsValid || isDealCurrencyArchived, [areLineItemsValid, canEditPaymentLinks, isDealCurrencyArchived]);
  const shouldDisableAddPaymentLink = useMemo(() => !(canEditAssociation && !isDealCurrencyUnsupported && completedApplication), [canEditAssociation, completedApplication, isDealCurrencyUnsupported]);
  const shouldDisableCreatePaymentLink = useMemo(() => !canEditPaymentLinks || isDealCurrencyArchived, [canEditPaymentLinks, isDealCurrencyArchived]);
  const disableCreatePaymentLinkMessage = useMemo(() => {
    if (!canEditPaymentLinks) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.noCreateAccess"
      });
    } else if (isDealCurrencyArchived) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociateObjectButton.tooltip.paymentCreationTooltipTextArchivedCurrency"
      });
    }
    return null;
  }, [canEditPaymentLinks, isDealCurrencyArchived]);
  const disableConvertDealToLinkTooltipMessage = useMemo(() => {
    if (!canEditPaymentLinks) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.noCreateAccess"
      });
    } else if (!areLineItemsValid) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.cantConvertIncompatibleLineItems"
      });
    } else if (isDealCurrencyArchived) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociateObjectButton.tooltip.paymentConversionTooltipTextArchivedCurrency"
      });
    }
    return null;
  }, [areLineItemsValid, canEditPaymentLinks, isDealCurrencyArchived]);
  const actionsDropdown = useMemo(() => {
    return /*#__PURE__*/_jsx(Tooltip, {
      disabled: !shouldDisableAddPaymentLink,
      title: editAssociationOverrideMessage,
      children: /*#__PURE__*/_jsx(Dropdown, {
        id: PAYMENT_LINK_CARD_ACTION_ADD_DROPDOWN_ID,
        buttonUse: "link",
        buttonSize: "small",
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.add"
        }),
        disabled: shouldDisableAddPaymentLink,
        onOpenComplete: () => {
          handleTrackingAction(CLICK_PAYMENT_LINK_ADD_ACTION);
        },
        children: /*#__PURE__*/_jsxs(List, {
          wrapChildren: true,
          children: [shouldShowConvertDealToLink && /*#__PURE__*/_jsx(Tooltip, {
            disabled: !shouldDisableConvertDealToLink,
            title: disableConvertDealToLinkTooltipMessage,
            children: /*#__PURE__*/_jsx(Button, {
              id: PAYMENT_LINK_CARD_CONVERT_DEAL_BUTTON_ID,
              disabled: shouldDisableConvertDealToLink,
              onClick: () => {
                handleTrackingActionWithCommerceAnalytics(CONVERT_PAYMENT_LINK_FROM_DEAL_ACTION);
                setShouldDisplayConvertDealIframe(true);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.convertDealToLink"
              })
            })
          }), /*#__PURE__*/_jsx(Tooltip, {
            disabled: !shouldDisableCreatePaymentLink,
            title: disableCreatePaymentLinkMessage,
            children: /*#__PURE__*/_jsx(Button, {
              disabled: shouldDisableCreatePaymentLink,
              onClick: () => {
                handleTrackingActionWithCommerceAnalytics(CREATE_PAYMENT_LINK_FROM_DEAL_ACTION);
                setShouldDisplayCreateIframe(true);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.createNewLink"
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: () => {
              handleTrackingAction(ASSOCIATE_PAYMENT_LINK_TO_DEAL_ACTION);
              setShouldDisplayPaymentLinkAssociationPanel(true);
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "cardAssociatedObjects.chicklet.PaymentLinkCardAction.addExistingLink"
            })
          })]
        })
      })
    });
  }, [disableConvertDealToLinkTooltipMessage, shouldDisableConvertDealToLink, shouldDisableAddPaymentLink, editAssociationOverrideMessage, shouldShowConvertDealToLink, shouldDisableCreatePaymentLink, disableCreatePaymentLinkMessage, handleTrackingAction, handleTrackingActionWithCommerceAnalytics]);
  const paymentLinkCardAction = useMemo(() => /*#__PURE__*/_jsxs(_Fragment, {
    children: [isPaymentLinkModalOpen && /*#__PURE__*/_jsx(SharePaymentLinkModalAsync, {
      closeModal: () => setIsPaymentLinkModalOpen(false),
      paymentLinkId: paymentLinkId,
      paymentLinkCrmObjectId: paymentLinkCrmObjectId,
      fromObjectTypeId: fromObjectTypeId,
      hasScope: hasScope
    }), shouldDisplayCreateIframe && /*#__PURE__*/_jsx(ModalIFrame, {
      embeddedPassthruProps: {
        dealCurrency,
        recordName,
        isOneTimeUseEnabled: true
      },
      appName: "paymentLinkOnePageApp",
      use: "fullscreen",
      onReady: () => {},
      onClose: () => setShouldDisplayCreateIframe(false),
      height: "100%",
      src: `/payment-links/${portalId}/iframe/create`,
      onMessage: handleMessageFromIframe,
      width: "100%"
    }), shouldDisplayConvertDealIframe && /*#__PURE__*/_jsx(ModalIFrame, {
      embeddedPassthruProps: {
        dealCurrency,
        dealLineItemNodes,
        recordName,
        isOneTimeUseEnabled: true
      },
      appName: "paymentLinkOnePageApp",
      use: "fullscreen",
      onReady: () => {},
      onClose: () => setShouldDisplayConvertDealIframe(false),
      height: "100%",
      src: `/payment-links/${portalId}/iframe/create`,
      onMessage: handleMessageFromIframe,
      width: "100%"
    }), shouldDisplayPaymentLinkAssociationPanel && /*#__PURE__*/_jsx(PaymentLinkAssociationPanelAsync, {
      setShouldDisplayPaymentLinkAssociationPanel: setShouldDisplayPaymentLinkAssociationPanel,
      associationTypeData: associationTypeData,
      fromObjectId: fromObjectId,
      fromObjectTypeId: fromObjectTypeId,
      toObjectTypeId: toObjectTypeId,
      createAssociationBySpecMutation: createAssociationBySpecMutation,
      setIsPaymentLinkModalOpen: setIsPaymentLinkModalOpen,
      setPaymentLinkCrmObjectId: setPaymentLinkCrmObjectId,
      setPaymentLinkId: setPaymentLinkId
    }), actionsDropdown]
  }), [isPaymentLinkModalOpen, paymentLinkId, paymentLinkCrmObjectId, fromObjectTypeId, hasScope, shouldDisplayCreateIframe, dealCurrency, recordName, portalId, handleMessageFromIframe, shouldDisplayConvertDealIframe, dealLineItemNodes, shouldDisplayPaymentLinkAssociationPanel, associationTypeData, fromObjectId, toObjectTypeId, createAssociationBySpecMutation, actionsDropdown]);
  return paymentLinkCardAction;
};
export default PaymentLinkCardAction;